// staticAssumptionService.js

import axiosInstance from "../axiosInstance";

export const staticAssumptionService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post("/static-assumption", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetch: async (searchValue, query = "", signal) => {
    try {
      let api_query = `/static-assumption?`;

      // Add search value
      if (searchValue) api_query += `&item[$search]=${searchValue}`;
      if (query.length) api_query += `&${query}`;

      const response = await axiosInstance.get(api_query, { signal });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchById: async (id, signal) => {
    try {
      let query = `/static-assumption/${id}`;
      let response = await axiosInstance.get(query, { signal });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (data, id, signal) => {
    try {
      let response = await axiosInstance.patch(
        `/static-assumption/${id}`,
        {
          ...data,
        },
        { signal },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/static-assumption/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
